import { render, staticRenderFns } from "./video-upload-modal.vue?vue&type=template&id=bbfc51a6&scoped=true&"
import script from "./video-upload-modal.vue?vue&type=script&lang=js&"
export * from "./video-upload-modal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=0&id=bbfc51a6&scoped=true&lang=scss&"
import style1 from "./video-upload-modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfc51a6",
  null
  
)

component.options.__file = "video-upload-modal.vue"
export default component.exports